export const projectData = [
  {
    id: 24,
    name: "Ethereal Matter",
    youtube_url: "iIITG1E5RWo",
    description:
      "<p><a className='std' href='https://www.ethereal-matter.com/'>Ethereal Matter</a> is a robotic chassis tethered to a VR headset, which allows the user to interact with the world in a way that is not possible with traditional controller based VR schemes. Dynaminc resistance or assistance can be applied, creating the ideal platform for gamified exercise in either realistic, or fantastic situations.</p><p>Role: <b>Lead Experience Developer</b></p>",
    related_assets: ["314eb799-5127-4715-af65-96918661cbba"],
    catalog_tile_image: "ethereal.png",
    tags: ["work", "experiences"],
  },
  {
    id: 23,
    name: "REAL® System",
    youtube_url: "iIITG1E5RWo",
    description:
      "<p><a className='std' href='https://www.realsystem.com/'>REAL® System</a> is a virtual reality (VR) rehabilitation tool that allows providers, such as physical therapists, occupational therapists, and speech language pathologists, to customize therapy sessions for high-acuity to high-functioning patients.</p><p>REAL System is developed by <a className='std' href='https://www.penumbra.com/'>Penumbra Inc.</a></p><p>Role: <b>Engineering Manager</b></p>",
    related_assets: [
      "33f43dc1-7f3a-466f-a5c9-0909e73263a9",
      "580f48a8-9dc8-40d9-becc-099dedf8dab5",
      "ccbda568-ffe6-4aa7-8ba3-0628b460c072",
    ],
    catalog_tile_image: "real0.png",
    tags: ["work", "experiences"],
  },
  {
    id: 22,
    name: "SONGAID™",
    description:
      "<p><a className='std' href='https://songaid.com'>SongAid™</a> is a platform where the simple act of listening to music, engaging in dialogue and sharing on social media helps in the fight for equal rights and justice. Funds generated from SongAid content go to organizations investing in the foundations of equality: ending hunger and poverty, creating educational and economic opportunities, criminal justice reform, improving health and well-being, and environmental preservation.</p><p>Role: <b>Advisor / Developer</b></p>",
    related_assets: ["7c04621b-f530-4b39-bd1c-71cc9351976e"],
    catalog_tile_image: "songaid1.png",
    tags: ["work", "experiences"],
  },
  {
    id: 21,
    name: "TRACKTRIBE™",
    description:
      "<p><a href='https://tracktribe.com'>TrackTribe</a> is a collective of artists, musicians and technology professionals. We provide creative services and high-quality music for creators, media companies and fans. We are committed to making a positive global impact by empowering creative communities and supporting social causes. Our tracks have sonically powered millions of videos on youtube and various other platforms, and have been streamed and downloaded billions of times.</p><p>Role: <b>Advisor / Developer</b></p>",
    related_assets: [
      "9f8e1800-a8f8-4d87-b558-12d9f000de7b",
      "4b5d5751-d484-4586-a0f4-871981739ca7",
      "e0bb2cf2-5c12-46ee-9ae2-0773406420bd",
    ],
    catalog_tile_image: "tracktribe.png",
    tags: ["work", "experiences"],
  },
  {
    id: 20,
    name: "COPA STC",
    youtube_url: "bRLuDuViPiw",
    description:
      "<p><a href='https://copastc.com'>CopaSTC</a> is a next generation soccer training facility focused on improving player performance through the use of data in conjunction with a staff of world class trainers, and cutting edge devices. Curriculum designed and led by ex-pro soccer players, and coaches. Activities span basic soccer technique, agility and cognitive training, as well as speed and strength training.</p><p>Role: <b>Engineering Manager / Lead Developer</b></p>",
    related_assets: [
      "e26f385c-aa52-4e02-a1a3-373cb0f9218b",
      "8b01fe12-9bca-455b-a582-a0a3324efe7c",
      "3d7bfcf2-abdb-4600-88ac-7a852fa7d22f",
    ],
    catalog_tile_image: "copa.png",
    tags: ["work", "experiences"],
  },
  {
    id: 19,
    name: "SAMSUNG QLED TV",
    youtube_url: "TG_5oY2T98Y",
    description:
      "<p>To promote the launch of their QLED TV line, <a href='https://www.samsung.com/us/'>Samsung</a> in partnership with <a href='https://www.encoreww.com/'>Encore Worldwide</a> created a multi-room, expandable, doublewide semi trailer installation that traveled the country showcasing the capabilities of this best in class TV.</p><p>In it's first phase, the installation contained a projection mapped room, and a series of XBOX One enabled racing sleds where users competed in Forza Horizon for a chance to win a QLED TV.</p><p>We created the projection mapping experience, and the leaderboard / registration system for the racers. In the second phase, we replaced the racing sleds with 3 Kinect-driven football receiver games. This was then taken around the college football tailgate circuit.</p><p>Role: <b>Development Director / Experience Designer</b></p>",
    related_assets: [
      "79d1a6d0-7ddc-4049-bc0e-778798c4742d",
      "fbe003e9-93c1-458f-8d41-db6c53f79abf",
      "0e06d77f-b651-4086-a2ab-9ac0ebedbf98",
      "9b4a2eeb-1605-41b1-bb37-143ca15de2d6",
      "7f38e624-0f3c-471c-a408-292a8265ed95",
      "1eb4c205-06ac-4454-bdd0-32f1569a653f",
      "4e508a8d-1b34-4fc4-b576-12eccfa932d5",
    ],
    catalog_tile_image: "samsung.png",
    tags: ["work", "experiences"],
  },
  {
    id: 18,
    name: "SHOPPERTRACK",
    youtube_url: "mkEiyiOVF2Y",
    description:
      "<p><a className='std' href='https://www.sensormatic.com/shoppertrak-retail-traffic-insights'>Shoppertrack</a> Retail Lab set about to create a suite of experiences to innovate the customer experience in the physical retail space. </p><p>Among several projects within this group was the Interactive Shoe Wall; a video display enabled grid of shoes, which ran ambient video content behind the entire display.</p><p>Interactions with each shoe were tracked in real time, and relevant video content was shown behind any shoe that customers interacted with.</p><p>Role: <b>Developer</b></p>",
    related_assets: ["8582673c-d986-46f2-b43a-994b9d5248de"],
    catalog_tile_image: "shoppertrack1.png",
    tags: ["work", "experiences"],
  },
  {
    id: 17,
    name: "BUD LIGHT VIRTUAL FITTING ROOM",
    youtube_url: "jWmwVOIIcRM",
    description:
      "<p>Virtual fitting room for various Bud Light related events and shows comissioned by <a href='https://www.anheuser-busch.com/'>Anheuser Busch</a>.</p><p>Users selected swag, which was then virtually overlaid on their bodies on a video wall. Swag could be purchased or given away as prizes. Photos of virtually overlaid users were emailed to them procedurally by the installation.</p><p>Role: <b>Developer</b></p>",
    related_assets: ["89bb1ac7-0eb3-4c1a-860d-76504ccfe088"],
    catalog_tile_image: "budlight_fittingroom.png",
    tags: ["work", "experiences"],
  },
  {
    id: 16,
    name: "BEN HUR",
    youtube_url: "3BmeR9GYdDU",
    description:
      "<p>To accompany the 2016 release of the Ben Hur movie, <a className='std' href='https://www.warnerbros.com/'>Warner Brothers</a> commisioned us to create a free downloadable, single player XBOX 360 game based on the chariot racing sequence in the movie.</p><p>Players raced as Ben Hur against several AI opponents in a series of 3 races of increasing difficulty. Picture-in-picture cam captured slow motion destruction of chariots in collisions around you.</p><p>Role: <b>Lead Designer / Developer</b></p>",
    related_assets: ["875e9469-7160-4851-9e2c-79e4fb153a6b"],
    catalog_tile_image: "benhur.png",
    tags: ["work", "games"],
  },
  {
    id: 15,
    name: "THE JORDAN STANDARD",
    youtube_url: "vzlu8y_eKXo",
    description:
      "<p>In concert with the NBA All-Star Weekend in 2016, Nike launched a Jordan store in Toronto, Canada. Among the many special features within the store was The Jordan Standard; a basketball training experience meant to challenge players, and measure their performance in 5 key aspects against the legend himself.</p><p>The experience was displayed on a massive LED wall, and driven by 3 sensors (2 Kinects, 1 bluetooth basketball) to provide real time performance stats, and dynamic difficulty ramping through 5 different skill-based drills.</p><p>Role: <b>Lead Designer / Lead Developer</b></p>",
    related_assets: [
      "4891beaf-db14-4842-8a9c-05f1f7692c32",
      "3d704590-d2ef-4d17-a01d-917a656ca09a",
      "b60afe18-e25a-4616-b114-5925e69fcb10",
      "b56c6cde-c605-4a62-aa44-a3682f167b26",
      "afb02f67-30a0-46cd-abea-996bbea7e828",
      "b18128ec-9a7b-4a83-98ff-87b1e756db4d",
    ],
    catalog_tile_image: "jordan.png",
    tags: ["work", "games", "experiences"],
  },
  {
    id: 14,
    name: "DAQRI SMART HELMET",
    youtube_url: "OVNDi1aHJiw",
    description:
      "<p>For CES 2016, Daqri announced their Augmented Reality enabled Helmet for the future of work by way of a real time demo.</p><p>The demo featured a series of activities showcasing the helmet's abilities to communicate information to it's wearer on an AR layer, based on physical objects around them.</p><p>The helmet contained a full suite of capabilities including gyroscopic menu navigation, wifi, infrared camera, and voice control.</p><p>Role: <b>Lead Designer / Developer</b></p>",
    related_assets: [
      "e3a0da0e-1952-460f-90f5-3ec6692f1991",
      "8c747419-7e96-4502-85b9-4f7f214031fc",
      "bcb963b3-31b1-4dc1-b05f-d27cc8a1a5e1",
      "662bffd3-d6b8-4e10-8a2a-ef1baa678ca3",
      "a3734813-b599-40eb-bb1e-2853bc66d8a2",
      "0b508898-e284-4f83-9405-b58a29a2fa8a",
      "ba638bca-8fa9-4136-a960-0b49e3e64d94",
    ],
    catalog_tile_image: "daqri.png",
    tags: ["work", "experiences"],
  },
  {
    id: 13,
    name: "PEPSI SXSW2015",
    youtube_url: "NUwtRM7hNTE",
    description:
      "<p>Interactive vending machine experience built for <a className='std' href='https://www.pepsico.com/'>PepsiCo</a>'s #FutureOfTheFest campaign at South by Southwest 2015.</p><p>Customers interacted with a futuristic virtual fortune telling android. Kinect tracked the position of the user, and enabled the fortune teller to look at and gesture to users accurately. Touchscreen enabled drink selection. Event specific fortunes were given to event attendees at the end of each interaction.</p><p>Role: <b>Lead Designer / Lead Developer</b></p>",
    related_assets: [
      "d7488032-eed8-45d0-90f9-1c2b1ab12140",
      "4e2c0899-096f-4900-a9d5-c73115334782",
    ],
    catalog_tile_image: "PSXSW2015.png",
    tags: ["work", "experiences"],
  },
  {
    id: 12,
    name: "TMNT:TRAINING LAIR",
    youtube_url: "VZZ0PnDZdZk",
    description:
      "<p>In 2014 <a className='std' href='https://www.paramountmovies.com/'> Paramount</a> in conjunction with Michael Bay rebooted the  Teenage Mutant Ninja Turtles franchise with a movie. To increase buzz around the movie, we created a Kinect-driven XBOX 360 game to showcase the weapons of the turtles.</p><p>Player is composited into the 3D world via the kinect's rgb camera, and various weapons are placed in the player's hands. Each weapon has its own collision shape. Psi were throwable.</p><p>Role: <b>Lead Designer / Developer</b></p>",
    related_assets: [
      "619440fb-f98c-4fec-84e4-b7e26a919b5e",
      "113e29d9-ec49-4216-a648-a4f95e06a51a",
      "03ef6ecc-185e-407a-b0ae-811226478f22",
    ],
    catalog_tile_image: "tmnt.png",
    tags: ["work", "games", "experiences"],
  },
  {
    id: 11,
    name: "PEPSI FOOTBALL 2014",
    youtube_url: "yfuh7f1PBpY",
    description:
      "<p>Kinect Driven DDR style soccer juggling game for Pepsi's Football Worldwide Live For Now campaign during the 2014 World Cup.</p><p>Players pose-matched against an animated character juggling a soccer ball. Earning the minimum point threshold won a free pepsi for the player.</p><p>The game was installed on 40+ vending machines throughout Europe, The Middle East, South Africa, and The United States.</p><p>Role: <b>Lead Designer / Principle Developer</b></p>",
    related_assets: [
      "4ad7f62c-2165-4a67-81a8-88bf073ff4cc",
      "22b99078-5113-49df-b6fd-2aedd41d979c",
      "c8f1de69-7893-432c-b8fe-02c74fcd403d",
      "24dbf344-6a17-4d36-b63e-128839b7a6b3",
    ],
    catalog_tile_image: "pepsi_worldcup.png",
    tags: ["work", "games", "experiences"],
  },
  {
    id: 10,
    name: "STAR WARS:ULTIMATE SITH EDITION",
    description:
      "<p>A follow up to the Force Unleased II, this was a DLC pack containing some original content, as well as revisits to worlds seen in previous TFU editions.</p><p>Return to Kashyk as Vader. Rampage on Bespin as the Sith Lord version of Starkiller. Additional fan favorite gems such as a boss fight against Darth Maul were also in this release.</p><p>Available on XBOX 360 and PS3.</p><p>Role: <b>Senior Designer</b></p>",
    related_assets: [
      "61c95603-857b-4224-aad1-b980d311324f",
      "a9b71ecc-8875-4455-adb0-9d81b2f6b649",
      "556630e5-7480-448b-8ef8-e286d8a17dd1",
      "559de6ad-3998-4050-b105-017d754dbd5c",
      "e37dd0ef-8b93-45f9-98a6-3419d09f18f0",
    ],
    catalog_tile_image: "ultimate_sith.png",
    tags: ["work", "games"],
  },
  {
    id: 9,
    name: "STAR WARS:THE FORCE UNLEASHED II",
    description:
      "<p>3rd person action adventure for XBOX 360, and PS3. Developed and published by Lucasarts in 2010.</p><p>Continue the adventures of Starkiller, Vader's secret apprentice, now free from the constraints of his old master.</p><p>Featured upgraded force moves, improved light saber combat, and additional locations.</p><p>Role: <b>Senior Designer</b></p>",
    related_assets: [
      "ffbfed91-fdad-401c-be8a-9b946fc78136",
      "ee0a25a9-746b-4d4c-b3f5-3239d1ccd174",
      "b655f898-7bf6-48be-9f45-d7ec3d8aee1f",
      "83e9ff7d-1b48-4a2c-8298-8c4b769a77a7",
      "bea31f60-cdad-445e-bd79-5b69a6fbf0f1",
    ],
    catalog_tile_image: "tfu2.png",
    tags: ["work", "games"],
  },
  {
    id: 8,
    name: "DANTE'S INFERNO",
    youtube_url: "-35gTPPBRUU",
    description:
      "<p>3rd person action adventure take on Virgil's classic book of the same name. Developed and published by Electronic Arts for XBOX 360, and PS3 in 2010.</p><p>Though I was primarily responsible for the 5th circle of Hell (Anger), I did additional scripting and combat tuning in several other areas throughout the game including the King Midas Boss Fight, Crossing the River Styx on Phlegyus, Phlegyus Boss Fight, and the decent into the final boss fight with Satan.</p><p>Role: <b>Senior Designer</b></p>",
    related_assets: [
      "9e8b598b-b7ea-4f71-8b56-a8673d6c4325",
      "d6af1776-8731-419b-b7f2-bfb088d6011b",
      "23e2433a-96cd-4ac3-9c7d-cf7b0f8117f8",
      "c5dc4ccb-4316-4c66-91b6-944913f1a638",
      "54972113-4896-40c9-907a-848f4a60f016",
      "7fb61b81-651c-4405-b280-11ab980bf0eb",
      "edef895f-f90a-48d1-a273-1778a1c90083",
      "f6c859e8-621e-414b-949e-3c0fe051d71a",
      "ca9cdbb2-161a-43d7-a7a3-1c8f0550b12c",
    ],
    catalog_tile_image: "dantes.png",
    tags: ["work", "games"],
  },
  {
    id: 7,
    name: "STAR WARS:THE FORCE UNLEASHED",
    description:
      "<p>3rd person action adventure based on the adventures of Starkiller - Darth Vader's secret apprentice. Set between Episode III and Episode IV, this marks the birth of the the rebellion.</p><p>Developed and published by <a href='https://www.starwars.com/games-apps'>Lucasarts</a> for XBOX 360, and PS3 in 2010.</p><p>Level design/layout, and all combat/object interactivity scripting for Raxus Prime, plus additional scripting on various levels throughout the game.</p><p>Role: <b>Senior Designer</b></p>",
    related_assets: [
      "13900d46-ce23-41b4-9dc3-1cb2fd8ed2cc",
      "1fcce7df-df9e-4b0c-a0ab-911e5755a19f",
      "7d658127-1d3f-4ebf-89a2-15be2172df7f",
      "ebd1503e-b12d-4523-b470-408e10d3cc3b",
      "b2a3d315-041d-4c55-8ae1-c0fdac27c980",
      "ba347beb-2336-4019-b4ed-4d0c366bb2de",
      "00d97f97-dfcb-457b-a9b8-10de1f2636b0",
      "75c0a59b-b587-4795-8bb6-7ca0ca2c01e6",
    ],
    catalog_tile_image: "tfu1.png",
    tags: ["work", "games"],
  },
  {
    id: 6,
    name: "CONAN",
    description:
      "<p>3rd person action adventure set in the fictional world of Howard/Frizetta. Developed by Nihilistic, published by THQ for XBOX 360 and PS3 in 2005.</p><p>Level design, layout and combat scripting all throughout the game.</p><p>Role: <b>Lead Level Designer</b></p>",
    related_assets: [
      "8310d3b1-19cd-4bd8-81d3-6921f0042c78",
      "938a9af7-336f-467a-85a6-d6a91d1c85f7",
      "c67030c8-e3aa-4fcc-99d0-469f875f66f1",
      "35fd58cf-b89f-4030-8359-7f3e25755c7c",
      "1837ea7e-246a-4572-8a6b-dc54c6a49474",
    ],
    catalog_tile_image: "conan.png",
    tags: ["work", "games"],
  },
  {
    id: 5,
    name: "MARVEL:NEMESIS",
    description:
      "<p>3rd person arena combat game in the Marvel universe. Developed by Nihilistic Software, published by <a href='https://www.ea.com/'>Electronic Arts</a> in 2005. Level design / layout, combat and boss fight scripting for several areas throughout the game.</p><p>Role: <b>Level Designer</b></p>",
    related_assets: [
      "c1c441d1-920e-491c-9cf4-1ba06d0c5d0d",
      "33507129-ecc0-4756-9b18-05b4198ea284",
      "eda85df2-7a2c-4f52-92f5-7625f1f4ccf2",
      "9b76ac5b-2998-4322-af64-42cb919ccb34",
      "31b0f641-e401-4120-9662-665442287426",
      "786609f8-7f25-4577-beb7-3f8619f13ffb",
    ],
    catalog_tile_image: "nemesis.png",
    tags: ["work", "games"],
  },
  {
    id: 4,
    name: "STARCRAFT:GHOST",
    description:
      "<p>3rd person action adventure based on the iconic character that first appeared in the Starcraft RTS. Developed by Nihilistic Software and <a href='https://www.blizzard.com/'>Blizzard Entertainment</a> for XBOX and PS2.</p><p>Penetrate enemy territory undetected, take out enemies and objectives from the shroud of Nova's cloaked suit.Level design and combat / puzzle scripting throughout various areas within the game.</p><p>This was the greatest game to have never shipped.</p><p>Role: <b>Level Designer</b></p>",
    related_assets: [
      "0a585f38-1425-4f03-bdd6-a3eae3fd347a",
      "c6cf88f8-e612-4fff-bc7c-5ea0a8d9e081",
      "ebd85fa9-6d0a-4e63-9bc6-05bce37da847",
      "5d1debc5-6190-437e-9b72-d173e46cca46",
      "38849918-7e96-465d-88fa-ae5e8216ab98",
      "a7698afc-3209-419a-b64e-245447bbf7d7",
      "10fc2d1a-a530-4848-a196-5e32585cce12",
      "39e08260-f284-499b-8cb5-96cadfd81a36",
      "3171bfdf-2dcd-44dd-a643-381aba57ca99",
      "2c6099f3-ed16-4bab-922c-db2227e822dd",
    ],
    catalog_tile_image: "ghost.png",
    tags: ["work", "games"],
  },
  {
    id: 3,
    name: "PSYCHONAUTS",
    youtube_url: "aDbDShqvc_o",
    description:
      "<p>3rd person action adventure for XBOX. Developed by <a href='https://www.doublefine.com/'>Doublefine</a>, published by Majesco in 2005. Level design, interaction, load control, and puzzle scripting throughout Campgrounds, Lungfishopolis , Milkman Conspiracy, Gloria's Theatre, and the Asylum Upper Floors.</p><p>Role: <b>Level Designer</b></p>",
    related_assets: [
      "ce655637-570b-46f4-acb4-487cfde1f8b6",
      "56766d89-41cd-4cd1-b1e2-6328cdc8149d",
      "2af8b9e9-4ab2-4fcc-897c-efc246be5b6a",
      "5916755a-f360-49fe-a767-a18a55c3c6d2",
      "d947e9f7-e51f-4a93-8d1d-4b217247e9ad",
      "e964292f-cf36-445d-a534-08aa25f40781",
    ],
    catalog_tile_image: "psychonauts.png",
    tags: ["work", "games"],
  },
  {
    id: 2,
    name: "INDIANA JONES AND THE INFERNAL MACHINE",
    description:
      "<p>Level Design on 3rd person action adventure game for PC and N64. Published by <a href='https://www.starwars.com/games-apps'>Lucasarts</a> 1999.</p><p>Worked primarily on Canyonlands, Shambala Waterworks area, and Palawan Volcano Temple. Responsible for level layout, combat and puzzle scripting, texturing and lighting.</p><p>Role: <b>Level Designer</b></p>",
    related_assets: [
      "36556edf-4ad7-4f50-a096-ffe8f212b88d",
      "0843644e-5c76-45ca-a623-fbdcc1c46792",
      "12aca23e-f23c-4616-99bf-0caf5b1c113c",
      "aa56551a-0a13-4362-bfef-52042461ebea",
    ],
    catalog_tile_image: "jones.png",
    tags: ["work", "games"],
  },
  {
    id: 1,
    name: "JEDI KNIGHT:MYSTERIES OF THE SITH",
    description:
      "<p>3rd person action adventure for PC. Published by <a href='https://www.starwars.com/games-apps'>Lucasarts</a> 1998. Design, modeling, lighting and scripting on Karobanis Base, and the Reactor Core Multiplayer level. </p><p>Role: <b>Level Designer</b></p>",
    related_assets: [
      "d28ce5d9-865d-4636-985e-5484d2e53ae0",
      "6d1bb15e-2bba-41ed-86cd-4a69b0f072ba",
      "ac727ed0-3819-4464-9dc2-a8831b2bb10f",
      "00a423bd-f047-4013-a0a9-403f75c8fb7a",
    ],
    catalog_tile_image: "sith.png",
    tags: ["work", "games"],
  },
];
